import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

const StyledCTA = styled.section`
  padding: 100px 0;
  background: linear-gradient(to right, #2e7d32, #1b5e20);
  position: relative;
  overflow: hidden;
  
  &:before {
    content: '';
    position: absolute;
    top: -100px;
    right: -100px;
    width: 300px;
    height: 300px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.05);
  }
  
  &:after {
    content: '';
    position: absolute;
    bottom: -100px;
    left: -100px;
    width: 400px;
    height: 400px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.05);
  }
  
  .cta-content {
    position: relative;
    z-index: 2;
    text-align: center;
    color: #fff;
    
    h2 {
      font-size: 2.8rem;
      font-weight: 800;
      margin-bottom: 20px;
      
      span {
        color: #ff9800;
      }
      
      @media (max-width: 768px) {
        font-size: 2.2rem;
      }
    }
    
    p {
      font-size: 1.2rem;
      max-width: 700px;
      margin: 0 auto 30px;
      opacity: 0.9;
      
      @media (max-width: 768px) {
        font-size: 1.1rem;
      }
    }
    
    .btn {
      padding: 15px 30px;
      font-weight: 600;
      font-size: 1.1rem;
      border-radius: 50px;
      transition: all 0.3s ease;
      
      &:hover, &:focus {
        transform: translateY(-3px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
      }
    }
    
    .btn-primary {
      background-color: #ff9800;
      border-color: #ff9800;
      margin-right: 15px;
      
      &:hover, &:focus {
        background-color: #f57c00;
        border-color: #f57c00;
      }
      
      @media (max-width: 576px) {
        margin-right: 0;
        margin-bottom: 15px;
      }
    }
    
    .btn-outline-light {
      &:hover, &:focus {
        background-color: #fff;
        border-color: #fff;
        color: #2e7d32;
      }
    }
    
    .buttons-container {
      display: flex;
      justify-content: center;
      gap: 15px;
      
      @media (max-width: 576px) {
        flex-direction: column;
      }
    }
  }
`;

const CallToAction = ({ 
  title = "Ready to Sell Your Land?",
  subtitle = "Get a fair cash offer for your land today. No obligations. No hassles. Just a simple path to selling your property.",
  primaryButtonText = "Get Your Cash Offer",
  secondaryButtonText = "Learn More",
  primaryButtonLink = "/get-offer",
  secondaryButtonLink = "/how-it-works" 
}) => {
  return (
    <StyledCTA>
      <Container>
        <Row className="justify-content-center">
          <Col lg={10}>
            <div className="cta-content">
              <h2>{title} <span>Get Started Now</span></h2>
              <p>{subtitle}</p>
              <div className="buttons-container">
                <Button as={Link} to={primaryButtonLink} className="btn-primary">
                  {primaryButtonText} <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
                </Button>
                <Button as={Link} to={secondaryButtonLink} variant="outline-light">
                  {secondaryButtonText}
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </StyledCTA>
  );
};

export default CallToAction;
